import React, { useCallback, useEffect } from 'react';
import { Switch, Redirect, Route, BrowserRouter as Router } from 'react-router-dom';
import { Paths, UserPath } from './routePaths';
import Login from '../Pages/Login';
import DashBoard from '../Pages/DashBoard';
import PageNotFound from '../Pages/PageNotFound';
import Administrators from '../Pages/Administrators';
import Customers from '../Pages/SuperAdmin/Customers';
import CreateCustomer from '../Pages/SuperAdmin/Customers/Create';
import CustomerInsights from '../Pages/SuperAdmin/CustomerInsights';
import Projects from '../Pages/SuperAdmin/Projects';
import ProjectInsights from '../Pages/SuperAdmin/ProjectInsights';
import Users from '../Pages/Users';
import Courses from 'Pages/Courses';
import AddUsers from '../Pages/Users/addUsers'
import AddAdministrator from '../Pages/Administrators/addAdministrator'
import AddCourses from '../Pages/Courses/addCourses'
import UpdateUsers from '../Pages/Users/updateUsers';
import Profile from '../Pages/Profile'
import Licenses from '../Pages/Licenses'
import MyAssesssments from '../Pages/MyAssesssments'
import { AuthProvider } from '../Context';
import AppRoutes from './AppRoutes';
import Reporting from '../Pages/Reporting';
import LearningService from '../Pages/Reporting/LearningService';
import Calendar from '../Pages/Calendar';
import DigitalReadliness from '../Pages/Reporting/DigitalReadliness';
import UserDashboard from '../Pages/UserAdmin/UserDashboard';
import Assessments from '../Pages/UserAdmin/Assessments';
import CourseCatalogue from '../Pages/UserAdmin/SkillTransformation/CourseCatalogue';
import LearningHub from '../Pages/UserAdmin/SkillTransformation/LearningHub';
import RegisteredCourses from '../Pages/UserAdmin/SkillTransformation/RegisteredCourses';
import VirtualGlobalApprenticeship from '../Pages/UserAdmin/SkillTransformation/VirtualGlobalApprenticeship';
import ChangePassword from '../Pages/Profile/ChangePassword';
import Deployments from '../Pages/Deployments';
import AddDeployment from '../Pages/Deployments/addDeployment';
import CustomerOnBoarding from '../Pages/CustomerOnBoarding';
import Experiments from '../Pages/SuperAdmin/Experiments';
import AddExperiment from '../Pages/SuperAdmin/Experiments/AddExperiment';
import ThemeEditor from '../Pages/ThemeEditor';
import { authService } from 'Services/AuthService';
import SuperadminLearnerRouteGuard from './SuperadminLearnerRouteGuard';
import { resetThemeColors } from '../utils';
import CourseRequests from 'Pages/CourseRequests';
import LearningHubRequests from 'Pages/LearningHubRequests';
import ForgotPassword from 'Pages/ForgotPassword';
import WorkReadiness from 'Pages/UserAdmin/SkillTransformation/WorkReadiness';
import CourseProvider from 'Context/CourseProvider';
import { PLATFORM_HOST_NAME } from 'utils/constants';
import DigitalTalentMaturity from 'Pages/Reporting/DigitalTalentMaturity';
import AIMaturity from 'Pages/Reporting/AIMaturity';
import RegisteredGroupCourses from 'Pages/UserAdmin/SkillTransformation/RegisteredGroupCourses';
import { RouteTransitionProvider } from '../Components/RouteTransition';

const Routes = () => {

    const routes = [
        {
            path: Paths.Login,
            component: Login,
            isPrivate: false,
            standalone: true,
            skeletonVariant: 'form'
        },
        {
            path: Paths.ForgotPassword,
            component: ForgotPassword,
            isPrivate: false,
            standalone: true,
            skeletonVariant: 'form'
        },
        {
            path: Paths.Dashboard,
            component: DashBoard,
            isPrivate: true,
            skeletonVariant: 'dashboard'
        },
        {
            path: Paths.SuperadminCustomerInsights,
            component: CustomerInsights,
            isPrivate: true,
            skeletonVariant: 'dashboard'
        },
        {
            path: Paths.SuperadminProjectInsights,
            component: ProjectInsights,
            isPrivate: true,
            skeletonVariant: 'dashboard'
        },
        {
            path: Paths.SuperadminProjects,
            component: Projects,
            isPrivate: true,
            skeletonVariant: 'table'
        },
        {
            path: Paths.ChangePassword,
            component: ChangePassword,
            isPrivate: true,
            skeletonVariant: 'form'
        },
        {
            path: Paths.Administrators,
            component: Administrators,
            isPrivate: true,
            skeletonVariant: 'table'
        },
        {
            path: Paths.Customers,
            component: Customers,
            isPrivate: true,
            skeletonVariant: 'table'
        },
        {
            path: Paths.Users,
            component: Users,
            isPrivate: true,
            skeletonVariant: 'table'
        },
        {
            path: Paths.Courses,
            component: Courses,
            isPrivate: true,
            skeletonVariant: 'table'
        },
        {
            path: Paths.Deployments,
            component: Deployments,
            isPrivate: true,
            skeletonVariant: 'table'
        },
        {
            path: Paths.createDeployment,
            component: AddDeployment,
            isPrivate: true,
            skeletonVariant: 'form'
        },
        {
            path: Paths.updateDeployment,
            component: AddDeployment,
            isPrivate: true,
            skeletonVariant: 'form'
        },
        {
            path: Paths.Experiments,
            component: Experiments,
            isPrivate: true,
            skeletonVariant: 'table'
        },
        {
            path: Paths.AddExperiment,
            component: AddExperiment,
            isPrivate: true,
            skeletonVariant: 'form'
        },
        {
            path: Paths.MyAssessments,
            component: MyAssesssments,
            isPrivate: true,
            skeletonVariant: 'cards'
        },
        {
            path: Paths.AddUsers,
            component: AddUsers,
            isPrivate: true,
            skeletonVariant: 'form'
        },
        {
            path: Paths.AddAdministrator,
            component: AddAdministrator,
            isPrivate: true,
            skeletonVariant: 'form'
        },
        {
            path: Paths.UpdateAdministrator,
            component: AddAdministrator,
            isPrivate: true,
            skeletonVariant: 'form'
        },
        {
            path: Paths.AddCourses,
            component: AddCourses,
            isPrivate: true,
            skeletonVariant: 'form'
        },
        {
            path: Paths.UpdateUsers,
            component: UpdateUsers,
            isPrivate: true,
            skeletonVariant: 'form'
        },
        {
            path: Paths.updateCourses,
            component: AddCourses,
            isPrivate: true,
            skeletonVariant: 'form'
        },
        {
            path: Paths.createCustomer,
            component: CreateCustomer,
            isPrivate: true,
            skeletonVariant: 'form'
        },
        {
            path: Paths.Profile,
            component: Profile,
            isPrivate: true,
            skeletonVariant: 'form'
        },
        {
            path: Paths.Liceses,
            component: Licenses,
            isPrivate: true,
            skeletonVariant: 'cards'
        },
        {
            path: Paths.Reporting,
            component: Reporting,
            isPrivate: true,
            skeletonVariant: 'report-overview'
        },
        {
            path: Paths.CustomerOnBoarding,
            component: CustomerOnBoarding,
            isPrivate: true,
            skeletonVariant: 'form'
        },
        {
            path: Paths.DigitalReadliness,
            component: DigitalReadliness,
            isPrivate: true,
            skeletonVariant: 'dashboard'
        },
        {
            path: Paths.DigitalTalentMaturity,
            component: DigitalTalentMaturity,
            isPrivate: true,
            skeletonVariant: 'maturity-report'
        },
        {
            path: Paths.AIMaturity,
            component: AIMaturity,
            isPrivate: true,
            skeletonVariant: 'maturity-report'
        },
        {
            path: Paths.LearningService,
            component: LearningService,
            isPrivate: true,
            skeletonVariant: 'report-table'
        },
        {
            path: Paths.Calendar,
            component: Calendar,
            isPrivate: true,
            skeletonVariant: 'calendar'
        },
        {
            path: UserPath.UserDashboard,
            component: UserDashboard,
            isPrivate: true,
            skeletonVariant: 'cards'
        },
        {
            path: UserPath.Assessments,
            component: Assessments,
            isPrivate: true,
            skeletonVariant: 'cards'
        },
        {
            path: UserPath.CourseCatalogue,
            component: CourseCatalogue,
            isPrivate: true,
            skeletonVariant: 'course-catalogue'
        },
        {
            path: UserPath.LearningHub,
            component: LearningHub,
            isPrivate: true,
            skeletonVariant: 'learning-hub'
        },
        {
            path: UserPath.RegisteredCourses,
            component: RegisteredCourses,
            isPrivate: true,
            skeletonVariant: 'course-list'
        },
        {
            path: UserPath.MyLearningHubCourses,
            component: RegisteredCourses,
            isPrivate: true,
            skeletonVariant: 'course-list'
        },
        {
            path: UserPath.RegisteredGroupCousres,
            component: RegisteredGroupCourses,
            isPrivate: true,
            skeletonVariant: 'cards'
        },
        {
            path: UserPath.WorkReadyness,
            component: WorkReadiness,
            isPrivate: true,
            skeletonVariant: 'cards'
        },
        {
            path: UserPath.VirtualGlobalApprenticeship,
            component: VirtualGlobalApprenticeship,
            isPrivate: true,
            skeletonVariant: 'cards'
        },
        {
            path: Paths.ThemeEditor,
            component: ThemeEditor,
            isPrivate: false,
            skeletonVariant: 'form'
        },
        {
            path: Paths.CourseRequests,
            component: CourseRequests,
            isPrivate: true,
            skeletonVariant: 'table'
        },
        {
            path: Paths.LearningHubRequests,
            component: LearningHubRequests,
            isPrivate: true,
            skeletonVariant: 'table'
        },
        {
            path: '/*',
            component: PageNotFound,
            isPrivate: false,
            standalone: true,
            skeletonVariant: 'content'
        }
    ];

    const getThemedata = useCallback(async () => {
        let bURL = window.location.hostname;
        const themeData = localStorage.getItem('themeData')
            ? localStorage.getItem('themeData')
            : undefined;
        if (themeData === undefined) {
            await authService
                .gettheme(bURL)
                .then(response => {
                    const companyLogo = response.status === false
                        ? response.data.company_logo
                        : response.data.logo;
                    if (companyLogo) {
                        localStorage.setItem('company_logo', companyLogo);
                    } else {
                        localStorage.removeItem('company_logo');
                    }
                    if (response.status !== false) {
                        localStorage.setItem(
                            'themeData',
                            JSON.stringify(response.data.config.colors)
                        );
                    }
                    resetThemeColors(response?.data?.config?.colors || null);
                })
                .catch(function (error) {
                    localStorage.removeItem("company_logo");
                    console.log(error);
                });
        } else {
            var themeDatas = JSON.parse(themeData);
            resetThemeColors(themeDatas);
        }
        const hostName = window.location.hostname;
        if (!PLATFORM_HOST_NAME.includes(hostName)) {
            document.title = 'Learning Platform';
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement('link');
                link.rel = 'icon';
                document.getElementsByTagName('head')[0].appendChild(link);
            }
            if (localStorage.getItem('ssoToken')) {
                const companyLogo = localStorage.getItem('company_logo');
                if (companyLogo && companyLogo !== 'null' && companyLogo !== 'undefined') {
                    link.href = companyLogo;
                }
            }

        }
    }, []);

    useEffect(() => {
        const userRole = localStorage.getItem('role')
            ? localStorage.getItem('role')
            : undefined;
        if (userRole !== 'adminuser') {
            getThemedata();
        } else {
            resetThemeColors(null);
        }
    }, [getThemedata]);

    return (
        <AuthProvider>
            <CourseProvider>
                <Router>
                    <RouteTransitionProvider>
                        <SuperadminLearnerRouteGuard />
                        <Switch>
                            <Redirect
                                to={{ pathname: Paths.Dashboard }}
                                exact={true}
                                from={"/"}
                            />
                            <Route
                                exact
                                path={[UserPath.RegisteredCoursesLegacy, UserPath.RegisteredCoursesRoot]}
                                render={({ location }) => (
                                    <Redirect
                                        to={{
                                            pathname: UserPath.RegisteredCourses,
                                            search: location.search,
                                            hash: location.hash,
                                        }}
                                    />
                                )}
                            />
                            <Route
                                exact
                                path={UserPath.MyLearningHubCoursesLegacy}
                                render={({ location }) => (
                                    <Redirect
                                        to={{
                                            pathname: UserPath.MyLearningHubCourses,
                                            search: location.search,
                                            hash: location.hash,
                                        }}
                                    />
                                )}
                            />
                            {routes.map((route) => (
                                <AppRoutes
                                    exact={true}
                                    key={route.path}
                                    path={route.path}
                                    component={route.component}
                                    isPrivate={route.isPrivate}
                                    standalone={route.standalone}
                                    skeletonVariant={route.skeletonVariant}
                                />
                            ))}
                        </Switch>
                    </RouteTransitionProvider>
                </Router>
            </CourseProvider>
        </AuthProvider>
    )
};

export default Routes;
